'use client';

import {usePathname} from 'next/navigation';

export default function MobileDonButton({locale}: {locale: string}) {
  const pathname = usePathname();
  const isDonPage = pathname?.includes('/don');

  if (isDonPage) return null;

  return (
    <a
      href={`/${locale}/don`}
      className="fixed bottom-0 left-0 right-0 z-50 sm:hidden flex items-center justify-center gap-2 bg-secondary text-white font-semibold py-3 text-center shadow-[0_-2px_10px_rgba(0,0,0,0.15)]"
    >
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
      Faire un don
    </a>
  );
}
